import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { brattleboroConfig } from "./data";

export default function BrattleboroPage() {
  return <CityPageTemplate config={brattleboroConfig} />;
}